import {TemplateVersion, ToServerTemplateVersion} from 'notebook/entry-templates/TemplateConstants';
import * as net from 'util/Net';
import {StageConfiguration, WorkflowStage} from 'workflows/WorkflowConstants';

export interface FetchStageEntryTemplateResponse {
  stageConfiguration: StageConfiguration;
  latestVersionId: number;
  templateVersion: TemplateVersion;
}

export function fetch(stageConfigurationId: string): JQueryPromise<FetchStageEntryTemplateResponse> {
  return net.getJSON(`/1/api/workflows/stage-configurations/${stageConfigurationId}/stage-entry-template`);
}

export interface SaveStageEntryTemplateResponse {
  cidIdMap: {[cid: string]: string};
  workflowStage: WorkflowStage;
  stageConfiguration: StageConfiguration;
}

export function save(
  stageConfigurationId: string,
  {
    entryTemplateName,
    templateVersion,
    metadata,
  }: {
    entryTemplateName: string;
    templateVersion: ToServerTemplateVersion;
    metadata: {
      clientId: string;
      latestVersionId: number;
      action: string;
    };
  }
): JQueryPromise<SaveStageEntryTemplateResponse> {
  return net.patchJSON({
    url: `/1/api/workflows/stage-configurations/${stageConfigurationId}/stage-entry-template`,
    data: {entryTemplateName, templateVersion, metadata},
  });
}
